module.exports = __webpack_public_path__ + "static/img/freshman-python.3aa121d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/he/freshman-python.png
// module id = EZPh
// module chunks = 1